import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {Col, UiDivider, UiQuestionnaireLayout, UiText} from '~/components/elements';
import {ReviewList} from '~/components/shared/ReviewList';
import {VerticalImageList} from '~/components/shared/VerticalImageList';
import {PAGE_URLS} from '~/constants';
import {WEIGHT_LOSS_KEYS, WEIGHT_LOSS_ONE_QUESTIONNAIRES} from '~/constants/medical-questionnaires';
import {setQuestionnaireAnswer} from '~/redux/questionnaires/slice';
import {submitOrLogMdq} from '~/redux/questionnaires/thunk';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';
import {getTestimonials} from '~/redux/testimonials/slice';

interface Props {}

const Questionnaire2Screen = ({}: Props) => {
  const dispatch: AppDispatch = useDispatch();
  const history = useHistory();
  const mdq = useSelector((state: RootState) => state.questionnaires);
  const {methodKey, medicalUUID, answerOrder} = mdq;
  //   const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  //   const {wpAuthUser} = medicalQuestionnaire;

  //   const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = WEIGHT_LOSS_ONE_QUESTIONNAIRES.find(i => i.key === WEIGHT_LOSS_KEYS.HOW_IT_WORK);

  const {data: testimonialsData} = useSelector(getTestimonials);

  const collectedData = mdq.collectedData;

  const onClickSubmit = () => {
    const answerData = {
      key: WEIGHT_LOSS_KEYS.HOW_IT_WORK,
      index: questionnaire?.index || '',
      data: {},
      order: answerOrder + 1,
    };

    dispatch(setQuestionnaireAnswer(answerData));
    dispatch(
      submitOrLogMdq({
        data: {
          uid: medicalUUID,
          methodKey: methodKey.toLowerCase(),
          status: 'draft',
          data: {
            ...collectedData,
            [WEIGHT_LOSS_KEYS.HOW_IT_WORK]: answerData,
          },
        },
      }),
    );
    // dispatch(setNextQuestionnaire({value: WEIGHT_LOSS_KEYS.PROFILE}));
    history.push(PAGE_URLS.MDQ1_USER_DETAILS);
  };

  return (
    <UiQuestionnaireLayout
      actions={questionnaire?.actions}
      handleOnNext={onClickSubmit}
      pageTitle={questionnaire?.title}
    >
      <Col alignItems="center" textAlign="center" mt={8} px={2}>
        <Col mb={6}>
          <UiText fontSize="2xl" fontWeight="bold">
            {questionnaire?.questions?.default}
          </UiText>
        </Col>
        {questionnaire?.howItWorks && <VerticalImageList data={questionnaire.howItWorks} />}
        <UiDivider color="black" mb={6} px={1} />
        <ReviewList reviewList={testimonialsData} />
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire2Screen;
